// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import Switch from '../../../components/common/Switch';
import { __ } from '../../../i18n/l10n';
import GiftRaceBasketIcon from '../assets/img/gr_basket_toggle_icon.png';

const Wrap = styled.div`
  display: flex;
  align-items: center;

  .switch-label {
    white-space: nowrap;
  }
`;

const SwitchIconImg = styled.img`
  object-fit: cover;
  background-repeat: no-repeat;
  height: 1.6em;
  margin-right: 0.5em;
`;

const GRBasketIconComponent = (props) => <SwitchIconImg {...props} src={GiftRaceBasketIcon} />;

type Props = {
  className?: string;
  toggled: boolean;
  onToggle: (next: boolean) => void;
  autoToggleOnRender?: boolean;
  disabled: boolean;
};

const GRBasketSwitch = ({ className, toggled = false, autoToggleOnRender, onToggle, disabled }: Props) => {
  return (
    <Wrap className={className}>
      <Switch
        PrimaryIcon={GRBasketIconComponent}
        toggled={toggled}
        label={__('The Gift Race')}
        autoToggleOnRender={autoToggleOnRender}
        onToggle={onToggle}
        disabled={disabled}
      />
    </Wrap>
  );
};

export default GRBasketSwitch;
